import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import Env from '@ridango/core/env';
import { ApplicationFacade, PurchaseService } from '@ridango/components';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NextButtonElement, ProductArea, URLData } from '@ridango/components/lib/purchase/purchase.model';
import { takeUntil } from 'rxjs/operators';
import { BaseComponent } from '@ridango/core';

enum ModalType {
    original = 'original',
    destination = 'destination'
}

const currentStep = 'product-area';

@Component({
    selector: 'gl-purchase-v2-from-a-to-b-area',
    templateUrl: './from-a-to-b-area.component.html',
    styleUrls: ['./from-a-to-b-area.component.scss']
})
export class FromAToBAreaComponent extends BaseComponent implements OnInit, OnDestroy {
    public originArea = null;
    public destinationArea = null;
    public assetsPath$ = this.applicationFacade.assetsPath$;
    public modalType = null;
    public ModalType = ModalType;
    public preselectedOriginArea = null;
    public preselectedDestinationArea = null;
    public currentLanguage = this.translate.currentLang;

    @Input() productAreas: ProductArea[];
    @Input() set selectedProductAreas(value: URLData) {
        this.preselectProductAreas(value);
    }
    @Output() nextStep = new EventEmitter<void>();
    @Output() nextButtonElement = new EventEmitter<NextButtonElement>();
    @Output() errorEvent = new EventEmitter<string>();

    constructor(
        @Inject('ENV') public env: Env,
        private purchaseService: PurchaseService,
        private applicationFacade: ApplicationFacade,
        private activatedRoute: ActivatedRoute,
        public translate: TranslateService,
        private router: Router
    ) {
        super();
    }

    ngOnInit(): void {
        this.purchaseService.setPurchaseDataLoading(false);
        this.nextButtonElement.emit({
            content: { textTerm: 'BUTTON_NEXT' },
            disabled: !this.originArea || !this.destinationArea
        });
        this.translate.onLangChange.pipe(takeUntil(this.componentDestroyed$)).subscribe((event) => {
            this.currentLanguage = event.lang;
        });
    }

    ngOnDestroy(): void {
        this.nextButtonElement.emit(null);
        super.ngOnDestroy();
    }

    handleAreaClicked(modalType: ModalType | null) {
        this.modalType = modalType;
    }

    areaSelected(area) {
        if (this.modalType === ModalType.original) {
            this.preselectedOriginArea = area;
        } else {
            this.preselectedDestinationArea = area;
        }
    }

    handleSelectAreaClick() {
        if (this.modalType === ModalType.original) {
            this.originArea = this.preselectedOriginArea;
        } else {
            this.destinationArea = this.preselectedDestinationArea;
        }

        if (this.originArea && this.destinationArea) {
            const urlSegments = this.activatedRoute.snapshot.url.map((segment) => segment.path);
            const currentStepIndex = urlSegments.indexOf(currentStep);
            this.router.navigate([
                this.translate.currentLang,
                'purchase-v2',
                ...urlSegments.slice(0, currentStepIndex + 1),
                this.originArea.id,
                this.destinationArea.id
            ]);
        }

        this.modalType = null;

        this.nextButtonElement.emit({
            content: { textTerm: 'BUTTON_NEXT' },
            disabled: !this.originArea || !this.destinationArea
        });
    }

    handleModalDismiss() {
        this.modalType = null;
    }

    private preselectProductAreas(value: URLData): void {
        this.originArea = this.productAreas.find((a) => a.id === value.selectedProductAreas[0]);
        this.preselectedOriginArea = this.originArea;
        this.destinationArea = this.productAreas.find((a) => a.id === value.selectedProductAreas[1]);
        this.preselectedDestinationArea = this.destinationArea;
        if (value.selectedProductAreas.length > 0 && (!this.originArea || !this.destinationArea)) {
            this.errorEvent.emit('NOT_FIND_ANYTHING');
        }
        this.nextButtonElement.emit({
            content: { textTerm: 'BUTTON_NEXT' },
            disabled: !this.originArea || !this.destinationArea
        });
    }
}
